import { SpinningLoader } from '@frontend/design-system';

export const BulkMessageLoader = () => (
  <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <SpinningLoader size='xl' />
  </div>
);
